import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import differenceInSeconds from "date-fns/differenceInSeconds";

// AWS
import { API, Storage, Auth } from "aws-amplify";

function useGetAllLoanRequest({ ...query }) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(query);
  }, []);

  const getDataWithScan = async () => {
    const datas = await API.get("MoneyHubAdmin", "/loanRequest", {
      queryStringParameters: {
        ScanIndexForward: false,
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });
    const parseData = datas.body;
    let newDatas = await Promise.all(
      parseData?.Items?.map(async (data) => {
        return {
          ...data,
          // time_remain: format(calculateTimeRemain(data.timestamp), "hh:mm"),
          creditUri: !data.creditUri ? "" : await Storage.get(data.creditUri),
          attachment: !data.attachment
            ? ""
            : await Storage.get(data.attachment),
          pdpaUri: !data.pdpaUri ? "" : await Storage.get(data.pdpaUri),
          contractUri: !data.contractUri
            ? ""
            : await Storage.get(data.contractUri),
          statementUris: await getStatments(tryParseJSON(data.statementUris)),
          adminName: data.adminName,
          executeTime: data.executeTime,
          phone_number: data.phone_number,
          amount: data.amount,
          period: data.period,
          name: data.name + " " + data.lastname,
          loan_status: data.loan_status,
          timestamp: data.timestamp,
          pass: data.pass,
          purpose: data.purpose,
          totalScore: data.totalScore,
        };
      })
    );
    return newDatas;
  };

  function tryParseJSON(jsonString) {
    try {
      var o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {}

    return false;
  }
  const getStatments = async (statement) => {
    var arr = [];
    for (let i = 0; i < statement.length; i++) {
      let value = await Storage.get(statement[i]);
      arr.push({ value: value, title: statement[i] });
    }
    return arr;
  };

  const getDataDashboard = async (where) => {
    try {
      setLoading(true);
      const datas = await API.get("MoneyHubAdmin", "/loanRequest/sandbox", {
        queryStringParameters: {
          ...where,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(datas.body);
      setCount(datas.count);
      setDatas(parseData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  const checkParseJSONString = (jsonString = "") => {
    let parse = JSON.parse(jsonString);
    if (typeof parse === "string") {
      return JSON.parse(parse);
    }
    return parse;
  };

  function tryParseJSON(jsonString) {
    try {
      var o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {}

    return jsonString.length ? jsonString : false;
  }

  const getData = async (where = {}, options = { sortBy: "" }) => {
    try {
      setLoading(true);
      const datas = await API.get("MoneyHubAdmin", "/loanRequest", {
        queryStringParameters: {
          ...where,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const parseData = datas.body;
      const { identityId } = await Auth.currentCredentials();
      let newDatas = await Promise.all(
        parseData?.Items?.map(async (data, index) => {
          return {
            ...data,
            sort: +index + 1,
            identityId,
            request_id: data?.request_id,
            time_remain: 172800000 - (Date.now() - data.timestamp),
            newUpdate: differenceInSeconds(
              new Date().getTime(),
              parseInt(data.executeTime)
            ),
            originalBuro: data.fileBuro,
            fileBuro: !data.fileBuro ? "" : await Storage.get(data.fileBuro),
            creditUri: !data.creditUri ? "" : await Storage.get(data.creditUri),
            statementUris: !data.statementUris
              ? ""
              : await getStatments(tryParseJSON(data.statementUris)),
            // statementUrisMobile: !String(data?.statementUrisMobile)?.startsWith(
            //   "file://"
            // )
            //   ? await getStatments(tryParseJSON(data?.statementUrisMobile))
            //   : [],
            get_citizenUri: !data.citizenUri
              ? ""
              : await Promise.all(
                  checkParseJSONString(data.citizenUri).map(
                    async (uri, i) =>
                      await Storage.get(
                        uri.split("_")[1] + `_citizen_${i + 1}.jpeg`
                      )
                  )
                ),
            get_selfieUri: !data.selfieUri
              ? ""
              : await Storage.get(
                  data.selfieUri.split("_")[1] + `_selfie.jpeg`
                ),
            get_addressUri: !data.addressUri
              ? ""
              : await Storage.get(
                  data.addressUri.split("_")[1] + `_address.jpeg`
                ),
            get_bookbankUri: !data.bookbankUri
              ? ""
              : await Storage.get(
                  data.bookbankUri.split("_")[1] + `_bookbank.jpeg`
                ),
            attachment: !data.attachment
              ? ""
              : await Storage.get(data.attachment),
            pdpaUri: !data.pdpaUri ? "" : await Storage.get(data.pdpaUri),
            contractUri: !data.contractUri
              ? ""
              : await Storage.get(data.contractUri),

            adminName: data.adminName,
            executeTime: data.executeTime,
            phone_number: data.phone_number,
            amount: data.amount,
            period: data.period,
            name: data.name + " " + data.lastname,
            loan_status: data.loan_status,
            timestamp: data.timestamp,
            pass: data.pass,
            purpose: data.purpose,
            totalScore: data.totalScore,
          };
        })
      )

      if (options.sortBy) {
        newDatas = newDatas.sort((a, b) => b.sort - a.sort);
      }
      setCount(datas.count);
      setDatas(newDatas.slice(0, where?.Limit));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
    getDataWithScan,
    getDataDashboard,
  };
}

export default useGetAllLoanRequest;
